import CheckIcon from '@mui/icons-material/Check';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { houzyContact } from '../../../lib/houzyContact';
import { PARTNER_SUBSCRIPTION_ADVANTAGE_KEYS } from '../../../lib/partnerSubscriptionAdvantages';

export function SubscriptionFeatures(): ReactElement {
    const { t } = useTranslation();

    return (
        <Stack spacing={2}>
            <Typography variant="subtitle2">{t('SETTINGS.SUBSCRIPTION.FEATURES.TITLE')}</Typography>
            <Stack spacing={1}>
                {PARTNER_SUBSCRIPTION_ADVANTAGE_KEYS.map((key) => (
                    <Stack key={key} direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
                        <CheckIcon sx={{ fontSize: 20, color: 'action.active' }} />
                        <Typography variant="body2">{t(key)}</Typography>
                    </Stack>
                ))}
            </Stack>
            <Typography variant="body2" color="text.secondary">
                <Trans
                    i18nKey="SETTINGS.SUBSCRIPTION.FEATURES.PLAN_CHANGE_BY_CONTACT"
                    values={{ phone: houzyContact.partnerManagementPhoneNumber }}
                    components={{
                        phoneLink: <Link href={houzyContact.partnerManagementPhoneHref} underline="hover" />,
                        supportLink: <Link href={`mailto:${houzyContact.supportEmail}`} underline="hover" />,
                    }}
                />
            </Typography>
        </Stack>
    );
}
